import styled from "styled-components";
import buttonStyles from "./buttonStyles";

export const ButtonLink = styled.a`
  cursor: pointer;
  padding: 16px 30px;
  font-size: 14px;
  width: 100%;
  max-width: 250px;
  font-weight: 600;
  letter-spacing: 0px;
  line-height: 14px;
  display: inline-block;
  text-align: center;

  &:focus {
    outline: none;
  }

  &:visited {
    color: #fff;
  }

  ${({ className }) => (className ? "" : buttonStyles)}
`;




// WEBPACK FOOTER //
// ./src/components/Button/ButtonLink.js